/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_CaptionInputs */



/**
* | output |
* | --- |
* | "Last Caption:" |
*
* @param {Last_CaptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const last_caption = /** @type {((inputs?: Last_CaptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_CaptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dernière légende :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte Bildunterschrift:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultima didascalia:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Последняя подпись:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Último subtítulo:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最后一条说明文字：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後のキャプション:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम कैप्शन:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Última legenda:")
	return /** @type {LocalizedString} */ ("Last Caption:")
});